<template>
  <span data-locator="signature-count">
    {{$t('project.project-settings.signatures.ProjectSettingsSignaturesCount.countWithPrice', { count, price })}}

    <span v-if="isBillingByEnvelope"
          v-t="{
            path: 'project.project-settings.signatures.ProjectSettingsSignaturesCount.documentsCount',
            plural: documentsCount,
          }"
    />
  </span>
</template>

<script>
export default {
  name: 'ProjectSettingsSignaturesCount',
  props: {
    count: {
      type: Number,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    isBillingByEnvelope: {
      type: Boolean,
      default: false,
    },
    documentsCount: {
      type: Number,
      default: () => 0,
    },
  },
}
</script>
